<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('notificationtemplates.tags_title')"></page-header-title>

      <v-spacer></v-spacer>

      <v-form ref="form" @submit.prevent="filter" class="mt-8 d-none d-sm-flex">
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs6>
              <v-select
                v-model="search_params.type"
                :items="$dd_notification_template_type()"
                item-text="text"
                item-value="key"
                :label="$t('notificationtemplates.type')"
                @change="filter"
                hide-details
                clearable
              >
              </v-select>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                :label="$t('global.search')"
                v-model="search_params.any"
                @keydown="checkKeyPress"
                autocomplete="new-password"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-app-bar>

    <v-card>
      <v-card-text>
        <v-flex md12>
          <v-data-table
            :headers="headers"
            :items="notificationtemplates"
            :items-per-page="notificationtemplates.length"
            :options.sync="pagination"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
              'items-per-page-all-text': $t('global.items_per_page_all_text'),
              'items-per-page-text': $t('global.items_per_page_text'),
              'page-text': $t('global.page_text')
            }"
            :server-items-length="total"
            :loading="show_loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data_text')"
            :no-results-text="$t('global.no_results_text')"
            :must-sort="true"
          >
            <template v-slot:item.type="{ item }">
              {{ $dd_notification_template_type(item.type) }}
            </template>

            <template v-slot:item.updated_at="{ item }">
              {{ item.updated_at ? moment.utc(item.updated_at).format(DATE_FORMAT + " " + TIME_FORMAT) : "" }}
            </template>

            <template v-slot:item.actions="{ item }">
              <action-button type="edit" :icon_only="true" small @click="showEditTagModal(item)" />
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showEditTag" persistent max-width="700px">
      <div class="form-modal pa-4">
        <v-container class="pa-0">
          <v-card>
            <v-card-text class="pa-4">
              <v-simple-table dense>
                <tbody>
                  <tr>
                    <td colspan="2" class="text-center">
                      <b>{{ $t("notificationtemplates.available_tags") }}</b>
                    </td>
                  </tr>
                  <tr v-for="(value, key) in tags" :key="key">
                    <td class="pa-1" style="white-space: nowrap;">
                      <!--<v-chip small color="primary">{{ key }}</v-chip>--><b>{{ key }}</b>
                    </td>
                    <td class="pa-1" style="border-left: 1px solid rgba(0,0,0,0.2)">
                      <v-text-field dense hide-details v-model="tags[key]" autocomplete="new-password" />
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <action-button small type="cancel" @click="cancelEditTagModal" />
              <action-button small type="save" @click="updateTag()" />
            </v-card-actions>
          </v-card>
        </v-container>
      </div>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "NotificationList",

  data() {
    return {
      url: "",

      notificationtemplates: [],
      notificationtemplate: {},
      tags: [],

      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        page: this.$getLocalStorage("__page_NTTags_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["slug"]
      },
      search_params: {
        any: ""
      },

      showEditTag: false
    }
  },

  computed: {
    headers: {
      get() {
        return [
          { text: this.$t("notificationtemplates.slug"), value: "slug" },
          { text: this.$t("notificationtemplates.type"), value: "type" },
          {
            text: this.$t("global.actions"),
            value: "actions",
            width: "20%",
            align: "end",
            sortable: false
          }
        ]
      }
    }
  },

  watch: {
    refresh: {
      handler() {
        if (this.refresh) {
          localStorage.setItem("__notificationtemplateListSearchParams", JSON.stringify(this.search_params))
          this.list()
        }
      }
    },
    pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_NTTags_List", newVal.page)
          }

          this.refresh = true
        }
      }
    }
  },

  mounted() {
    this.url = this.API_URL + "notificationtemplates"
    if (localStorage.getItem("__notificationtemplateListSearchParams")) {
      this.search_params = JSON.parse(localStorage.getItem("__notificationtemplateListSearchParams"))
    }
  },

  methods: {
    list() {
      this.show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, this.search_params)

      axios.get(this.url + "?" + query).then((res) => {
        this.notificationtemplates = res.data.data
        this.total = res.data.meta.total
        this.refresh = false
        this.show_loading = false

        this.pagination.page = res.data.meta.current_page
        this.pagination.itemsPerPage = Number(res.data.meta.per_page)
      })
    },

    filter(target) {
      this.pagination.page = 1
      this.refresh = true
    },

    reset() {
      this.$refs.form.reset()
      this.pagination.page = 1
      this.refresh = true
    },

    checkKeyPress(e) {
      if (e.key == "Enter") {
        this.filter()
      }
    },

    showEditTagModal(record) {
      this.notificationtemplate = record
      this.tags = record.tags
      this.showEditTag = true
    },

    cancelEditTagModal() {
      this.notificationtemplate = {}
      this.tags = []
      this.showEditTag = false
    },

    updateTag() {
      let vm = this

      if (this.notificationtemplate) {
        axios
          .put(this.API_URL + "notificationtemplate", {
            id: this.notificationtemplate.id,
            tags: this.tags
          })
          .then((res) => {
            if (typeof res.data.errors !== "undefined") {
            } else {
              if (res.data.data.id) {
                vm.$awn.success(vm.$t("global.update_success"))
                vm.cancelEditTagModal()
              }
            }
          })
          .catch((err) => console.log(err))
      }
    }
  }
}
</script>

<style scoped></style>
